var lib_core      = require("lib-core");
var THREE         = require("three");
var lib_geometry      = require("lib-geometry");
var GlobalRotationModel  = require("./../abstract/globalRotationHandleModel.js");

var GlobalYRotationModel = function (editorModel, handleId, config) {
    GlobalRotationModel.call(this, editorModel, handleId, config);

    this.axis = new THREE.Vector3(0,1,0);
};

lib_core.inherit(GlobalYRotationModel, GlobalRotationModel);
GlobalYRotationModel.$class = "GlobalYRotationModel";
module.exports = GlobalYRotationModel;


GlobalYRotationModel.prototype.getCurrentAngle = function(position){
    var subject = this.getSubject();
    var basePos = subject.getPosition();

    var vectorToCenter = position.sub(basePos);
    vectorToCenter.normalize();
    return Math.atan2(vectorToCenter.x, vectorToCenter.z);
}

